
import { Options } from "vue-class-component";
import ComponentConfigMixins from "../ComponentConfigMixins";

@Options({
    name: "flowable-common-form-components-description-config",
})
export default class DescriptionConfig extends ComponentConfigMixins {}
